import { ButtonDropdownProps } from '@amzn/awsui-components-core/button-dropdown';
import { PHONE_TOOL_URL } from 'src/constants/AppConstants';

export const PROFILE_DROPDOWN_ITEMS: ReadonlyArray<ButtonDropdownProps.ItemOrGroup> = [
  {
    id: 'general',
    text: 'MY STUFF',
    items: [
      { id: 'profile', text: 'Profile', href: 'https://atoz.amazon.work/profile' },
      { id: 'atoz', text: 'A to Z', href: 'https://atoz.amazon.work/' },
      { id: 'timeoff', text: 'Request Time Off', href: 'https://atoz.amazon.work/time' },
      {
        id: 'badge-report',
        text: 'My Badge Report',
        href: 'https://atoz.amazon.work/myhr/livehelp/landing?category=My%20Employment&type=In%20Office%20Expectations&item=Badge%20Report&preferredChannel=SSA'
      },
      { id: 'ivy', text: 'Ivy', href: 'https://ivy.talent.a2z.com/' },
      { id: 'tasks', text: 'Tasks', href: 'https://ivy.talent.a2z.com/tasks' }
    ]
  },
  {
    id: 'workplace',
    text: 'WORKPLACE',
    items: [
      { id: 'phonetool', text: 'Phone Tool', href: PHONE_TOOL_URL },
      { id: 'bookroom', text: 'Book Room / Meeting', href: 'https://meetings.amazon.com/#/room-booking' },
      { id: 'wiki', text: 'Wiki', href: 'https://w.amazon.com/bin/view/Main/' },
      { id: 'shout-outs', text: 'Shout Outs', href: 'https://atoz.amazon.work/shout-outs' },
      { id: 'password', text: 'Password Unlock', href: 'https://password-v2.corp.amazon.com/' }
    ]
  },
  {
    id: 'manage',
    text: 'MANAGER HUB',
    items: [
      { id: 'clarity', text: 'Clarity', href: 'https://clarity.people-insight.a2z.com/' },
      { id: 'roster', text: 'Roster', href: 'https://roster2.a2z.com/' },
      { id: 'blue-print', text: 'Blueprint', href: 'https://atoz.amazon.work/blueprint/scenario' },
      { id: 'hire', text: 'Hire', href: 'https://hire.amazon.com/' },
      { id: 'teams', text: 'Teams', href: 'https://permissions.amazon.com/a/team/' },
      { id: 'email-lists', text: 'Email Lists', href: 'https://email-list.corp.amazon.com/email-list/' }
    ]
  },
  {
    id: 'access',
    text: 'ACCESS',
    items: [
      { id: 'aws-access', text: 'AWS Account Access', href: 'https://iad.merlon.amazon.dev/accounts?filter=allAccounts#accounts' },
      { id: 'tickets', text: 'Trouble Ticketing', href: 'https://t.corp.amazon.com/' },
      { id: 'permissions', text: 'Permission Groups', href: 'https://permissions.amazon.com/' },
      { id: 'it-support', text: 'IT Support', href: 'https://my.it.a2z.com/' },
      { id: 'it-marketplace', text: 'IT Marketplace', href: 'https://marketplace.it.a2z.com/' }
    ]
  },
  {
    id: 'travel',
    text: 'TRAVEL',
    items: [
      { id: 'book-travel', text: 'Book Travel', href: 'https://app.spotnana.com/' },
      { id: 'trail', text: 'Trail', href: 'https://trail.amazon.dev/' },
      {
        id: 'travel-promos',
        text: 'Travel Promotions',
        href: 'https://w.amazon.com/bin/view/TravelAndEvents/BusinessTravelPromotions/'
      },
      { id: 'expenses', text: 'Submit Expenses', href: 'https://us2.concursolutions.com/home.asp' },
      { id: 'move-in-sync', text: 'Move in Sync', href: 'https://amz4.moveinsync.com/RAC/' }
    ]
  },
  {
    id: 'people',
    text: 'GROWTH',
    items: [
      { id: 'learning', text: 'Learning Hub', href: 'https://atoz.amazon.work/learn/home' },
      { id: 'job-finder', text: 'Job Finder', href: 'https://atoz.amazon.work/jobs/' },
      { id: 'helpful-links', text: 'Other Helpful Links', href: 'https://w.amazon.com/bin/view/Main/AmazonLinks' }
    ]
  }
];
